import { useAppConfig, useAssignedAppType, usePortalConfig, useToastApi, useTranslations } from '../core';
import { useAnonymousApi } from '../api';
import { ICoreContext } from '@vivli/core/infrastructure/interface';
import { useMemo } from 'react';

export const useCoreInit = (): ICoreContext => {
    const assignedAppType = useAssignedAppType();
    const portalConfig = usePortalConfig();
    const anonApi = useAnonymousApi();
    const config = useAppConfig({ anonApi, assignedAppType: assignedAppType.type, portalConfig });
    const translationsLoaded = useTranslations({ anonApi, assignedAppType: assignedAppType.type });
    const toastApi = useToastApi();

    // export core hooks (modal state lives in its own ModalProvider, not here, so opening a modal
    // does not re-render CoreContext consumers)
    return useMemo(
        () => ({
            assignedAppType,
            config,
            toastApi,
            anonApi,
            translationsLoaded,
            portalConfig
        }),
        [assignedAppType, config, toastApi, anonApi, translationsLoaded, portalConfig]
    );
};
